import { POSTHOG_TRACKING_EVENTS, PosthogTrackingSource } from '../constants';
import { CaptureTrackingEvent } from './types';

export const createNewsEvents = (
  captureTrackingEvent: CaptureTrackingEvent
) => {
  const trackNewsOpen = (source: PosthogTrackingSource) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.NEWS_OPEN,
      properties: { source },
    });

  const trackNewsDrawerOpen = (source: PosthogTrackingSource) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.NEWS_DRAWER_OPEN,
      properties: { source },
    });

  const trackNewsFilter = (
    source: PosthogTrackingSource,
    type: 'most_read' | 'watchlist'
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.NEWS_FILTER_SELECTED,
      properties: { source, type },
    });

  return { trackNewsOpen, trackNewsDrawerOpen, trackNewsFilter };
};
